import React from 'react';

import Constants from '../config.js'
import WorldMap2 from '../components/WorldMap/WorldMap2.js'
import TokkenR_Name from '../components/TokkenR_Name.js'


function Loading_Popup({ paused = false }) {
    const mainTextJSX = < div className="main-text" style={{ fontSize: "24px" }}>
        {/* Constants.WELCOME_MSS */} < br />
        {/* {Constants.WELCOME_TITLE} */}
        {/* &nbsp; <img id="" src={Constants.IMAGES.token_logo} style={{
            zoom: "0.07",
            }}/> */}
    </div >
    return (
        <div className="welcome-page" >

            <div className="welcome-page-content" style={{ height: "80vh" }}>

                {/* {mainTextJSX} */}
                <div style={{ height: "50px" }} /> {/* spacer */}

                <TokkenR_Name withLogo />
                <div style={{ height: "30px" }} /> {/* spacer */}

                <div style={{ fontSize: "24px" }}>
                    {Constants.WELCOME_DESCRIPTION}
                </div>
                <br /> <br />

                <div style={{ width: "min(40%, 50vh)", margin: "0 auto", }}>
                    <WorldMap2 paused={paused} />
                </div>

                {/* Button */}
                {/* < br />
                <div className="continue-button">
                    <NavLink to="/select_wallet">
                        <ButtonPrimary>
                            Continue
                        </ButtonPrimary>
                    </NavLink>
                </div> */}

            </div>

            {/* <footer>
                <br /><br />
                <div className="centered" style={{ color: "lightslategrey" }}>
                    {Constants.APP_VERSION}
                </div>
            </footer> */}

        </div >
    );
}

export default Loading_Popup;


